import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

/**
 * A component that renders a group of fields.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the field group.
 * @param {Object} [props.children] - Child elements to be rendered inside the field group.
 * @returns {JSX.Element} The rendered field group component.
 */
export function FieldGroup({ className, ...props }) {
  return (
    <div
      data-slot="control"
      {...props}
      className={clsx(className, 'space-y-8')}
    />
  );
}

FieldGroup.propTypes = {
  className: PropTypes.string,
};
